<template>
  <b-card>
    <b-card-body>
      <b-row>
        <b-col cols="1">
          <b-img
              :src="product.images && product.images[0] ? product.images[0].url : 'https://via.placeholder.com/60x60?text=Yok'"
              alt="Ürün Görseli"
              fluid
              thumbnail
              width="100"
              height="100"
          />
        </b-col>
        <b-col cols="4">
          {{ product.id }}
          <a v-if="product.productContentId"
             class="btn btnsize"
             target="mpproduct"
             :href="'https://www.trendyol.com/w/w-w-p-'+product.productContentId"
          >
            <b-btn variant="primary" size="sm">Link</b-btn>
          </a>
          <br>
          {{ product.merchant_sku }} <br>
          {{ product.product_name }} <br>
          {{ product.brandId }} <br>
          {{ product.status === 1 ? 'Aktif' : 'Pasif' }}
        </b-col>
        <b-col cols="4">
          <ProductSubProducts :product="product"/>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import ProductSubProducts from "@/views/v2/trendyol/product/ProductSubProducts.vue";

export default {
  name: 'TrendyolProductItem',
  components: {ProductSubProducts},
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>